import { useState } from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useGiftCardCheckoutValidation } from '../../../hooks/use-gift-card-checkout-validation';
import GiftCardReloadActionSheetWrapper from '../gift-card-reload-action-sheet';
import PlaceOrderButton from '../place-order-button';
import ReloadGiftCardButton from '../reload-gift-card-button';

export default function CheckoutActionButton() {
  const [showGiftCardReloadAndPayActionSheet, setShowGiftCardReloadAndPayActionSheet] =
    useState(false);

  const { showReloadGiftCardCTA } = useGiftCardCheckoutValidation();

  return (
    <>
      <SafeAreaView>
        {showReloadGiftCardCTA ? (
          <ReloadGiftCardButton onPress={() => setShowGiftCardReloadAndPayActionSheet(true)} />
        ) : (
          <PlaceOrderButton />
        )}
      </SafeAreaView>

      <GiftCardReloadActionSheetWrapper
        isOpen={showGiftCardReloadAndPayActionSheet}
        onClose={() => setShowGiftCardReloadAndPayActionSheet(false)}
      />
    </>
  );
}
